<template>
  <div class="comContent">
    <searchForm
      v-model="searchData"
      @getList="getList(1)"
      :labelList="searchLabelList"
      :searchData="searchData"
      @reset="resetForm"
      :showExport="false"
      :isShowAddress="true"
    ></searchForm>

    <myTable
      :index="index"
      :selection="false"
      :page="page"
      :showpage="true"
      :operation="false"
      v-loading="loading"
      :table-data="tableData"
      :table-option.sync="tableOption"
      
      @page-change="getList"
      :expand="false"
    >
      <template slot="applicationAreaProvinceName" slot-scope="scope"> 
        {{ scope.row.applicationAreaProvinceName }}
        <span v-if="scope.row.applicationAreaCityName"> - </span>
        {{ scope.row.applicationAreaCityName }}
        <span v-if="scope.row.applicationAreaName"> - </span>
         {{  scope.row.applicationAreaName }}
      </template>
      <template slot="auditStatus" slot-scope="scope">
        <!-- 审核状态(审核通过：PASS，审核驳回：REJECT，待审核：AWAIT_AUDIT) --> 
        <span style="color:#67C23A" v-if="scope.row.auditStatus == '通过'"><i class="el-icon-success" ></i> 审核通过</span> 
        <span style="color:#E6A23C"  v-if="scope.row.auditStatus == '待审核' "><i class="el-icon-warning"></i> 待审核</span>  
        <span style="color:#F5222d"  v-if="scope.row.auditStatus == '驳回' "><i class="el-icon-warning"></i> 审核驳回</span>  
      </template>
      <template slot="operation" slot-scope="scope"  >
           <!-- <el-link
          type="primary"
          :underline="false" 
          @click="updateStatus(scope.row, 1,'审核通过')"
          style="margin-right: 10px"
          v-if="scope.row.auditStatus == '待审核'"
        >
        
          审核通过
        </el-link>

        <el-link
        type="primary"
        :underline="false" 
        @click="updateStatus(scope.row, 2,'驳回')"
        style="margin-right: 10px"
        v-if="scope.row.auditStatus == '待审核'"
      >
      驳回
      </el-link> -->
      <el-link
          type="primary"
          :underline="false" 
          @click="handlerInfo(scope.row)"
          style="margin-right: 10px"
        >
          详情
        </el-link>
      </template>
    </myTable>

    <rejectDialog ref="reject-dialog" @getList="getList"/>
    <!-- 详情 -->
    <DetailDialog ref="detailDlg" @updateStatus="handlerUpdateStatus"></DetailDialog>
  </div>
</template>
<script>
import searchForm from "./components/searchForm.vue";
import rejectDialog from "./components/rejectDialog.vue";
import DetailDialog from "./components/detailDialog.vue";
import myTable from "@/components/myTable";
// /salesUser/page
import { getSalesUser,examineSalesUser} from "@/api/externalSalesRule";

export default {
  components: { searchForm, myTable,rejectDialog ,DetailDialog},
  props: {},
  data() {
    return {
      loading: false,
      operation: false,
      selection: true,
      index: false,
      page: {
        total: 11,
        current: 1,
        size: 10,
        pageSizes: [10, 20, 30, 50],
      },
      tableData: [],
      tableOption: [ 
        { label: "业务员姓名", prop: "salesUserName" },
        { label: "联系方式", prop: "contactInformation"}, 
        { label: "申请区域", prop: "applicationAreaProvinceName" , slot: true },  
        { label: "审核状态", prop: "auditStatus",  slot: true }, 
        {
          label: "操作",
          prop: "operation",
          slot: true,
          width: 120, 
        },
       
      ],
      searchData: {
         
      },
      searchLabelList: [ 
        {
          name: "业务员姓名",
          fieldName: "nameLike",
          width: 150,
          type: "input",
          disabled: false, 
        },
        {
          name: "联系方式",
          fieldName: "phone",
          width: 150,
          type: "input",
          disabled: false, 
        },
        {
          name: "省",
          fieldName: "province",
          type: "province",
          label:'申请区域'
        },
        {
          name: "市",
          fieldName: "city",
          type: "city",
        },
        {
          name: "区",
          fieldName: "area",
          type: "area",
        },

        {
          name: "状态",
          width: 150,
          fieldName: "auditStatus",
          type: "select",
          disabled: false,
          select: [
            {
              name: "审核通过",
              id: 'PASS',
            },
            {
              name: "待审核",
              id: 'AWAIT_AUDIT',
            },
            {
              name: "驳回",
              id: 'REJECT',
            },
          ],
        },
       
      ],
      currentRow: {}
    };
  },
  filters: {},
  created() {},
  mounted() { 
    this.getList(1);
  },
  methods: {

    // 详情
    handlerInfo(row){
      this.currentRow = {...row}
      this.$refs.detailDlg && this.$refs.detailDlg.init(row)
    },
    // 更新状态
    handlerUpdateStatus(status){
      if(status =='reject'){
        this.$refs['reject-dialog'].init(this.currentRow);
      }else{ 
        let params = {
          id: this.currentRow.id,
          status :'PASS', 
        } 
        this.$confirm(`确定通过【 ${this.currentRow.salesUserName}】吗?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.updateClientStatus(params);
          })
          .catch();  
      }
      
    }, 

    updateClientStatus(params){
      examineSalesUser(params).then((res)=>{
        if(res){
          this.$message.success('提交成功');
          this.getList(1)
        }else{
          this.$message.error(res.msg)
        } 
      }).finally(()=> this.closeAllDlg())
    },

 
    getList(current) {
      if(current){
        this.searchData.current = current;
      } 
      const params = Object.assign({}, this.searchData);
      if (this.searchData.province) {
        params.applicationAreaProvinceCode = this.searchData.applicationAreaProvinceCode;
        delete params.province;
      }
      if (this.searchData.city) {
        params.applicationAreaCityCode = this.searchData.applicationAreaCityCode;
        delete params.city;
      }
      if (this.searchData.area) {
        params.applicationAreaCode = this.searchData.applicationAreaCode;
        delete params.area;
      } 
      params.size = this.page.size;

      if (current) {
        params.current = 1;
        this.page.current =1;
      } else {
        params.current = this.page.current;
      }
      getSalesUser(params).then((res) => {
        console.log(res)
        if (res.records) {
          this.tableData = res.records;
          this.page.total = res.total;
        this.page.total = res.total;
        } else {
          this.tableData = [];
          this.page.total = 0;
        }
      });
      //
      this.closeAllDlg()
    },
    resetForm() {
      this.page.current = 1; 
       for (const key in this.searchData) { 
        this.searchData[key] ="" 
      }
      this.getList()
    },
    // 关闭弹窗
    closeAllDlg(){
      this.$refs['reject-dialog'] && this.$refs['reject-dialog'].close()
      this.$refs.detailDlg && this.$refs.detailDlg.close()
    }
    
  },
};
</script>
<style lang="scss" scoped>
::v-deep.el-table {
  height: calc(100% - 138px) !important;
}
::v-deep.zt__table {
  height: calc(100% - 118px) !important;
}

::v-deep.el-table .el-table__body-wrapper {
  height: calc(100% - 78px) !important;
  overflow-y: scroll !important;
}
</style>
